import { css } from "@emotion/react";
import React from "react";
import { Layout } from "../Layouts";
import { useTheme } from "../theme";

export interface CalendarUIHeaderProps {
  children?: React.ReactNode;
}

export const CalendarUIHeader = ({ children }: CalendarUIHeaderProps) => {
  const { spacing } = useTheme();
  return (
    <Layout.Row
      justify="space-between"
      alignItems="center"
      css={css`
        && {
          margin-bottom: ${spacing * 2}px;
        }
      `}
    >
      {children}
    </Layout.Row>
  );
};
